var _effectorFileName = "/builds/gmini/front-ui-kit/src/Logo/Logo.tsx";
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Logo = /*#__PURE__*/React.memo(() => /*#__PURE__*/_jsxs("svg", {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    d: "M3.5 0C1.567 0 0 1.567 0 3.5V32.5C0 34.433 1.567 36 3.5 36H32.5C34.433 36 36 34.433 36 32.5V3.5C36 1.567 34.433 0 32.5 0H3.5ZM4.21252 33.7897C3.10795 33.7897 2.21252 32.8943 2.21252 31.7897V4.21031C2.21252 3.10574 3.10795 2.21031 4.21252 2.21031H31.7875C32.8921 2.21031 33.7875 3.10574 33.7875 4.21031V31.7897C33.7875 32.8943 32.8921 33.7897 31.7875 33.7897H4.21252Z",
    fill: "#353B60"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 6.75C5.5 6.05964 6.05964 5.5 6.75 5.5H29.25C29.9404 5.5 30.5 6.05964 30.5 6.75V10.75C30.5 11.4404 29.9404 12 29.25 12H12.625C12.2798 12 12 12.2798 12 12.625L12 23.375C12 23.7202 12.2798 24 12.625 24H20.25C20.9404 24 21.5 24.5596 21.5 25.25V29.25C21.5 29.9404 20.9404 30.5 20.25 30.5H6.75C6.05964 30.5 5.5 29.9404 5.5 29.25V29V24V12V9V6.75ZM24 15H16.25C15.5596 15 15 15.5596 15 16.25V20.25C15 20.9404 15.5596 21.5 16.25 21.5H23.375C23.7202 21.5 24 21.7798 24 22.125V29.25C24 29.9404 24.5596 30.5 25.25 30.5H29.25C29.9404 30.5 30.5 29.9404 30.5 29.25V21.5V16.25C30.5 15.5596 29.9404 15 29.25 15H24Z",
    fill: "#00003D"
  })]
}));
Logo.displayName = 'Logo';